import QuestionCard from "pages/QuestionPage/QuestionCard/QuestionCard";

export default QuestionCard;
